import { Skeleton } from '@systemeio/components'

export const DeleteConfirmationLoader = () => (
  <div className="flex flex-col items-center gap-3">
    <Skeleton className="h-3 w-full rounded-lg text-transparent">.</Skeleton>
    <Skeleton className="h-3 w-full rounded-lg text-transparent">.</Skeleton>
  </div>
)
